// Hero banner slider.
//
// Auto-rotates through every [data-hero-slide] inside [data-hero-slider].
// Click on a [data-hero-dot] jumps to that slide and resets the timer.
// Pauses while the cursor is over the hero. Skips entirely when there is
// only one slide — the PHP doesn't render dots in that case anyway, so
// there's nothing to wire up.

(function () {
    function init() {
        document.querySelectorAll('[data-hero-slider]').forEach(setup);
    }

    function setup(root) {
        const slides = Array.from(root.querySelectorAll('[data-hero-slide]'));
        const dots   = Array.from(root.querySelectorAll('[data-hero-dot]'));
        if (slides.length <= 1) return;

        const ROTATE_MS = 6000;
        let active = 0;
        let timer  = null;

        const go = (idx) => {
            if (idx === active || idx < 0 || idx >= slides.length) return;
            // De-activate the current slide / dot
            slides[active].classList.remove('is-active');
            slides[active].setAttribute('aria-hidden', 'true');
            if (dots[active]) {
                dots[active].classList.remove('is-active');
                dots[active].removeAttribute('aria-current');
            }
            // Activate the new one
            active = idx;
            slides[active].classList.add('is-active');
            slides[active].setAttribute('aria-hidden', 'false');
            if (dots[active]) {
                dots[active].classList.add('is-active');
                dots[active].setAttribute('aria-current', 'true');
            }
        };

        const next = () => go((active + 1) % slides.length);

        const start = () => {
            stop();
            timer = setInterval(next, ROTATE_MS);
        };
        const stop = () => {
            if (timer !== null) {
                clearInterval(timer);
                timer = null;
            }
        };

        dots.forEach((dot, i) => {
            dot.addEventListener('click', (e) => {
                e.preventDefault();
                go(i);
                start(); // reset the auto-rotate so the new slide gets a full ROTATE_MS window
            });
        });

        // Pause auto-rotate while the cursor is over the hero (so users
        // reading the banner copy don't get yanked to the next slide).
        root.addEventListener('mouseenter', stop);
        root.addEventListener('mouseleave', start);

        // Pause when the tab is hidden (saves CPU + avoids visible jumps
        // when the user comes back).
        document.addEventListener('visibilitychange', () => {
            if (document.hidden) stop(); else start();
        });

        start();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
